import { parseElementFromString } from 'anodum';
import isFunction from '../../../utils/is-function';
import hdrm from '../../hdrm';
import site from '../../site';
import blocks from '../../blocks';
import globals from '../../globals';
import actionTypes from '../constants/action-types';
import getBlockVariations from '../../blocks/selectors/block-variations';
import { UPDATE_LIVE_ONLY } from '../../hdrm/constants/update-strategies';

const handleInsertBlockAction = (store, action) => {
  const { refElementId, blockId, variationId, position, blockModifier, options } = action.payload;
  const { strategy } = options;

  const state = store.getState();

  const block = blocks.selectors.getBlock(state, blockId);
  const variations = getBlockVariations(state, block.id);

  const variationHTML = variations.find((variation) => variation.id === variationId).html;

  const element = globals.helpers.injectGlobals(parseElementFromString(variationHTML));
  element.id = blocks.helpers.generateBlockId(blockId);
  element.setAttribute(blocks.attributes.VARIATION_ATTRIBUTE_NAME, variationId);

  if (isFunction(blockModifier)) blockModifier(element);

  return hdrm.operations.insertElement(element, refElementId, position, strategy);
};

const insertBlock = (store) => (next) => (action) => {
  switch (action.type) {
    case actionTypes.BULK_VIEW_ACTIONS: {
      const actions = action.payload.actions.filter(
        (targetAction) => targetAction.type === actionTypes.INSERT_BLOCK
      );

      if (!actions.length) {
        next(action);
        return;
      }

      const state = store.getState();
      const pageId = site.selectors.getActivePageId(state);

      const newHTML = actions.reduce((_, subAction) => {
        const { globalsToUpdate } = subAction.payload;
        globals.helpers.saveGlobals(globalsToUpdate);
        return handleInsertBlockAction(store, subAction);
      }, null);

      store.dispatch(site.actions.setPageHTML(pageId, newHTML));

      next(action);
      break;
    }
    case actionTypes.INSERT_BLOCK: {
      const { globalsToUpdate, options } = action.payload;
      const { strategy } = options;

      const newHTML = handleInsertBlockAction(store, action);

      if (strategy !== UPDATE_LIVE_ONLY) {
        const state = store.getState();
        const pageId = site.selectors.getActivePageId(state);

        globals.helpers.saveGlobals(globalsToUpdate);
        store.dispatch(site.actions.setPageHTML(pageId, newHTML));
      }

      next(action);
      break;
    }
    default:
      next(action);
  }
};

export default insertBlock;
